module.exports = __webpack_public_path__ + "static/ashburnhh-ecaf0d6bf00181824ae6a62a71913068.jpg";